import styles from './Audit.module.css';
import * as moment from 'moment';

import React, { Component, Fragment } from 'react';
import { ReactSVG } from 'react-svg';

import { UserService, AuditService} from '../../../services/ApiService';

import { CPLBanner } from '../../../components/Banner';
import { LanguageContext } from '../../../i18n/LanguageContext';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import {Typeahead} from 'react-bootstrap-typeahead';

import headerImage from './../images/modules/audit.jpg';

import filterIcon from './../icons/ic_filter.svg';
import archiveIcon from './../icons/ic_archive.svg';

export default class AuditModule extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);
        
        this.defaultStartDate = moment().startOf('month').format('YYYY/MM/DD');
        this.defaultEndDate = moment().endOf('month').format('YYYY/MM/DD');
        
        this.modules = [
            'DOCUMENT',
            'PURCHASER',
            'FEEDBACK',
            'NOTIFICATION',
            'USER',
            'COMMERCE',
            'CONTENT'
        ];

        this.events = [
            {
                group: 'DOCUMENT',
                options: [
                    
                    'CREATE_DOCUMENT',
                    'DELETE_DOCUMENT',
                    'UPDATE_DOCUMENT'
                ]
            },
            {
                group: 'FEEDBACK',
                options: [
                    'GET_FEEDBACK_BY_ID',
                    'GET_ALL_FEEDBACK'
                ]
            },
            {
                group: 'NOTIFICATION',
                options: [
                    'SET_NOTIFICATION_EMAIL',
                    'GET_NOTIFICATION_EMAIL_BY_ID',
                    'GET_ALL_NOTIFICATIONS_EMAIL'
                ]
            },
            {
                group: 'USER',
                options: [
                    'CREATE_USER',
                    'DELETE_USER',
                    'GET_USER_BY_ID',
                    'GET_ALL_USERS',
                    'UPDATE_USER'
                ]
            },
            {
                group: 'COMMERCE',
                options: [
                    'DOWNLOAD_COMMERCE_DOCUMENTS_BY_ID',
                    'GET_REQUEST_COMMERCES',
                    'GET_COMMERCE_HISTORY_BY_ID',
                    'GET_COMMERCE_DOCUMENTS_BY_ID',
                    'CREATE_COMMERCE',
                    'GET_COMMERCE_BY_ID'
                ]
            },
            {
                group: 'CONTENT',
                options: [
                    'CREATE_CONTENT',
                    'UPDATE_CONTENT',
                    'DELETE_CONTENT',
                    'UPLOAD_IMAGE_CONTENT',
                ]
            }
        ];

        this.validEvents = [];

        this.actions = [
            'CREATE',
            'DOWNLOAD',
            'DELETE',
            'UPDATE',
            'READ'
        ];


        this.state = {
            users: [],
            logs: [],
            isLoading: true,
            search: '',
            userSearch: '',
            userMapping: {},
            log: null
        };

        this.csv = '';
    }

    onSearch = (search) => {
        this.setState({ search });
    }

    onUserSearchChange = (user) => {
        this.setState({userSearch: user})
    }

    onClose = () => {
        this.setState({ log: null });
    }

    onFilterChange = (filter) => {
        this.setState({logs: [], log: null});

        const requestFilter = {
            startDate: filter.startDate,
            endDate: filter.endDate,
            filter: {
                module: filter.module,
                action: filter.action,
                event: filter.event,
                UserID: filter.user
            }
        }

        for(let item in requestFilter.filter) {
            if(!requestFilter.filter[item]) {
                delete requestFilter.filter[item];
            }
        }

        this.getLogs(this.state.userMapping, requestFilter)
            .then(logs => {
                this.setState({logs: logs});
            })
            .catch(err => console.error(err));
    }

    async componentDidMount() {
        let users = await this.getUsers();
        
        const userMapping = {};
        for(let user of users) {
            userMapping[`${user.UserID}`] = user;
        }

        let logs = await this.getLogs(userMapping);
        
        users = users.map(user => {
            return {
                id: user.UserID,
                name: `${user.name} ${user.lastName}`   
            }
        });
        this.setState({users: users, logs: logs, isLoading: false, userMapping: userMapping});
    }

    getUsers = async() =>{
        let users = await UserService.getUsers();
        return users;
    }

    getLogs = async (userMapping, filter = null) => {
        let logs = [];
        
        if(!!filter) {
            logs = await AuditService.get(filter);   
        } else {
            logs = await AuditService.get({
                startDate: this.defaultStartDate,
                endDate: this.defaultEndDate
            });   
        }
        
        logs = logs.filter(log => !!log.UserID)
            .filter(log => this.validEvents.indexOf(log.event) >= 0) 
            .map(log => {
                log.moduleName = this.context[log.module];
                log.actionName = this.context[log.action];
                log.eventName = this.context[`EVT_${log.event}`];
                
                log.userName = log.user.name;
                if(!log.userName) {
                    const user = userMapping[`${log.UserID}`];
                    if(!!user) {
                        log.userName = `${user.name} ${user.lastName}`;
                    }
                }

                log.date = moment(new Date(log.date)).format('YYYY/MM/DD hh:mm:ss a');
                return log;
            });

        return logs;
    }

    onRowClicked = (log) => {
        // TODO Delete this comment to enable details
        // this.setState({log});
    }

    render() {
        let logs = this.state.logs;
        const search = this.state.search;
        const userSearch = this.state.userSearch;

        if (!!search) {
            logs = logs.filter(log => this.filterLogs(search, log, [
                    'moduleName',
                    'actionName',
                    'eventName',
                    'userName',
                    'date'
            ]));
        }

        if(!!userSearch) {
            logs = logs.filter(log => this.filterLogs(userSearch, log, [
                'userName'
        ]));
        }

        const csv = logs.reduce((csv, item) => {
            const row = []
            row.push(item.module || '');
            row.push(item.action || '');
            row.push(item.event || '');
            row.push(item.UserID || '');
            row.push(item.userName || '');
            row.push(item.date || '');

            return `${csv}${row.join(',')}\n`;
        }, `MODULE,ACTION,EVENT,USER_ID,USER_NAME,DATE\n`);

        return <div className="col-md-12">
            <div className="row banner-wrapper">
                <div className="col-md-12">
                    <CPLBanner
                        img={headerImage}
                        content={this.context['AUDIT_ADMIN_MODULE_NAME']} />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12 col-md-7">
                    {!this.state.isLoading ? <LogsDisplay 
                        modules={this.modules}
                        events={this.events}
                        actions={this.actions}
                        users={this.state.users}
                        onRowClicked={this.onRowClicked}
                        logs={logs}
                        csv={csv}
                        onUserSearchChange={this.onUserSearchChange}
                        onDownloadClick={this.onDownloadClick}
                        onFilterChange={this.onFilterChange}
                        onSearch={this.onSearch}/> : null}
                </div>
                <div className="col-lg-3 col-md-5">
                    {!!this.state.log ? <LogDetailDisplay 
                        context={this.context}
                        onClose={this.onClose}
                        log={this.state.log}
                    /> : null}
                </div>
            </div>
        </div>
    }

    filterLogs(search, log, properties) {
        for (let prop of properties) {
            if (RegExp(`(.)*${search}(.)*`, 'i').test(log[prop])) {
                return true;
            }
        }
        return false;
    }
}

class LogsDisplay extends Component {

    static contextType = LanguageContext

    constructor(props, context) {
        super(props, context);
        this.state = {
            search: '',
            displayFilter: false,
            filter: {
                module: null,
                action: null,
                event: null,
                user: null,
                startDate: moment().startOf('month').format('YYYY/MM/DD'),
                endDate: moment().endOf('month').format('YYYY/MM/DD')
            }
        };
    }

    onSearchListener = (event) => {
        this.props.onSearch(event.target.value);
        this.setState({ search: event.target.value });
    }

    toggleFilterBar = () => {
        this.setState({displayFilter: !this.state.displayFilter});
    }

    onFilterChange = (filter) => {
        this.props.onFilterChange({...this.state.filter, ...filter});
        this.setState({filter: {...this.state.filter, ...filter}});
    }

    render() {
        const logs = this.props.logs;

        return <div>
            <div className="card">
                <div className="card-header">
                    <div className="row">
                        <div className='col-md-12'>
                            {this.context['LOGS']}
                            <span className="float-right">
                                <OverlayTrigger
                                    key="top"
                                    placement="top"
                                    overlay={<Tooltip>{this.context['DOWNLOAD']}</Tooltip>}>
                                    <div className={styles['panel-button']}>
                                        <a href={`data:text/csv;charset=utf-8,${encodeURI(this.props.csv)}`}
                                            target='_blank'
                                            rel="noopener noreferrer"
                                            download='logs.csv'>
                                            <ReactSVG
                                                src={archiveIcon}
                                                className={styles['download-button']} />
                                        </a>
                                    </div>
                                </OverlayTrigger>
                            </span>
                            <span className="float-right">
                                <OverlayTrigger
                                    key="top"
                                    placement="top"
                                    overlay={<Tooltip>{this.context['FILTER']}</Tooltip>}>
                                    <div className={styles['panel-button']} onClick={this.toggleFilterBar}>
                                        <ReactSVG
                                            src={filterIcon}
                                            className={styles['filter-button']} />
                                    </div>
                                </OverlayTrigger>
                            </span>
                            <span className="float-right">
                                <div className={styles['search-form']}>
                                    <input type="text" value={this.state.search} onChange={this.onSearchListener} placeholder={`${this.context['SEARCH']}...`} />
                                </div>
                            </span>
                        </div>
                    </div>
                    {this.state.displayFilter ? <FilterBar 
                            modules={this.props.modules}
                            events={this.props.events}
                            actions={this.props.actions}
                            users={this.props.users}
                            onUserSearchChange={this.props.onUserSearchChange}
                            onFilterChange={this.onFilterChange}
                            filter={this.state.filter} />:null}
                </div>
                <div className="card-body">
                    <table className="table table-borderless table-hover">
                        <thead>
                            <tr>
                                <th>{this.context['MODULE']} <b>({logs.length})</b></th>
                                <th>{this.context['ACTION']}</th>
                                <th>{this.context['EVENT']}</th>
                                <th>{this.context['USER']}</th>
                                <th>{this.context['DATE']}</th>
                            </tr>
                        </thead>
                        <LogList 
                            onRowClicked={this.props.onRowClicked}
                            logs={logs} />
                    </table>
                </div>
            </div>
        </div>
    }
}

class FilterBar extends Component {
    
    static contextType = LanguageContext

    constructor(props, context) {
        super(props, context);
        
        this.modules = this.props.modules;
        this.events = this.props.events;
        this.actions = this.props.actions;
        this.users = this.props.users;

        this.state = {
            search: '',
            displayFilter: false,
            filter: this.props.filter,
            errorComponent: null
        };
    }

    getValueFromIndex(array, value) {
        if(value === null) return null;

        const index = array.indexOf(value);
        if(index === -1) return null;
        return index;
    }

    getUserFromIndex(users, UserID) {
        if(UserID === null) return null;

        let index = null;
        users.forEach((user, i) => {
            if(user.id === UserID) {
                index = i;
            }
        });
        return index;
    }

    onModuleChange = (index) => {
        const filter = {
            module: null
        };
        
        if(index >= 0) {
            filter.module = this.modules[index];
        }

        this.props.onFilterChange({...this.state.filter, ...filter});
        this.setState({filter: {...this.state.filter, ...filter}});
    }

    onActionChange = (index) => {
        const filter = {
            action: null
        };
        
        if(index >= 0) {
            filter.action = this.actions[index];
        }

        this.props.onFilterChange({...this.state.filter, ...filter});
        this.setState({filter: {...this.state.filter, ...filter}});
    }

    onEventChange = (event) => {
        const filter = {
            event: event
        };

        this.props.onFilterChange({...this.state.filter, ...filter});
        this.setState({filter: {...this.state.filter, ...filter}});
    }

    onUserChange = (index) => {
        const filter = {
            user: null
        };
        
        if(index >= 0) {
            filter.user = this.users[index].id;
        }

        this.props.onFilterChange({...this.state.filter, ...filter}); 
        this.setState({filter: {...this.state.filter, ...filter}});
    }

    onStartDateChange = (e) => {
        if(!!e.target.value) {
            const endDate = this.state.filter.endDate;
            const date = moment(e.target.value).format('YYYY/MM/DD');

            if(moment(date).isAfter(endDate)) {
                this.setErrorComponent('ERROR_START_DATE_BIGGER_THAN_END_DATE');
            } else {
                const filter = {
                    startDate: date
                };
                
                this.props.onFilterChange({...this.state.filter, ...filter});
                this.setState({filter: {...this.state.filter, ...filter}});
                this.setErrorComponent();
            }
            
        }
    }

    onEndDateChange = (e) => {
        if(!!e.target.value) {
            const startDate = this.state.filter.startDate;
            const date = moment(e.target.value).format('YYYY/MM/DD');
            
            if(moment(date).isBefore(startDate)) {
                this.setErrorComponent('ERROR_END_DATE_SMALLER_THAN_START_DATE');
            } else {
                const filter = {
                    endDate: date
                };
                
                this.props.onFilterChange({...this.state.filter, ...filter});
                this.setState({filter: {...this.state.filter, ...filter}});
                this.setErrorComponent();
            }
        }
    }

    setErrorComponent = (errorMessage) => {
        const timeoutToDissolve = 3000;
        if(!errorMessage) {
            this.setState({errorComponent: null});
        } else {
            this.setState({errorComponent: <div className={styles['filter-bar-date-error']}>
                <p>{this.context[errorMessage]}</p>
            </div>});
            setTimeout(() => this.setState({errorComponent: null}), timeoutToDissolve);
        }
    }

    render() {
        const filter = this.props.filter;
        const selectedModule = this.getValueFromIndex(this.modules, filter.module);
        const selectedAction = this.getValueFromIndex(this.actions, filter.action);
        const selectedEvent = !!filter.event ? filter.event: '';
        const selectedUser= this.getValueFromIndex(this.users, filter.user);

        const modules = this.modules.map(mod => this.context[mod]);
        const actions = this.actions.map(action => this.context[action]);
        const events = this.events;
        const users = this.users.map(user => user.name);
        const startDate = moment(filter.startDate).format('YYYY-MM-DD');
        const endDate = moment(filter.endDate).format('YYYY-MM-DD');

        let moduleTitle = 'Seleccione un '
        if(this.context['LANG'] === 'en') {
            moduleTitle = 'Select a '
        }

        let actionTitle = 'Seleccione una '
        if(this.context['LANG'] === 'en') {
            actionTitle = 'Select an '
        }

        let eventTitle = 'Seleccione un '
        if(this.context['LANG'] === 'en') {
            eventTitle = 'Select an '
        }

        let userTitle = 'Seleccione un '
        if(this.context['LANG'] === 'en') {
            userTitle = 'Select a '
        }

        return <div className='row'>
            <div className={`col-md-12 ${styles['filter-bar']}`}>
                <DynamicSelect 
                    data={modules} 
                    title={moduleTitle + this.context['MODULE']}
                    selection={selectedModule}
                    onSelectChange={this.onModuleChange}/>
                <DynamicSelect 
                    data={actions} 
                    title={actionTitle + this.context['ACTION']}
                    selection={selectedAction}
                    onSelectChange={this.onActionChange}/>
                <DynamicOptGroupSelect 
                    data={events} 
                    title={eventTitle + this.context['EVENT']}
                    selection={selectedEvent}
                    onSelectChange={this.onEventChange}/>
                <UserAutocomplete 
                    data={users} 
                    onUserSearchChange={this.props.onUserSearchChange}
                    title={userTitle + this.context['USER']}
                    selection={selectedUser}
                    onSelectChange={this.onUserChange}/>
                <div>
                    <div className={styles['filter-bar-input-container']}>
                        <div className={styles['filter-bar-input-container-label']}>
                            <small>{this.context['START_DATE']}</small>
                        </div>
                        <div>
                            <input value={startDate} type="date" onChange={this.onStartDateChange} required/>
                        </div>
                    </div>
                    <div className={styles['filter-bar-input-container']}>
                        <div>
                            <small>{this.context['END_DATE']}</small>
                        </div>
                        <div>
                            <input value={endDate} type="date" onChange={this.onEndDateChange} required/>    
                        </div>
                    </div>
                    {this.state.errorComponent}
                </div>
            </div>
        </div>
    }
}

const UserAutocomplete = (props) => {
    return <div className={styles['user-input']}>
        <Fragment>
            <Typeahead
                id="user-selection"
                labelKey="user-selection"
                highlightOnlyResult={true}
                selectHintOnEnter={true}
                onChange={props.onUserSearchChange}
                multiple={false}
                options={props.data}
                placeholder={props.title}/>
        </Fragment>
    </div>
}

class DynamicSelect extends Component {

    static contextType = LanguageContext

    constructor(props) {
        super(props);
        let selection;
        if(this.props.selection !== null) {
            selection = this.props.selection + 1;
        } else {
            selection = 0
        }

        this.state = {
            selection: selection
        }
    }

    handleChange = (event) => {
        let selectedValue = parseInt(event.target.value);
        const dataIndex = selectedValue -1;
        this.props.onSelectChange(dataIndex);
        this.setState({selection: selectedValue});
    }

    render() {
        const data = [...[this.props.title], ...this.props.data];
        const options = data.map((option, index) => <option key={index} value={index}> {option} </option>);

        return <div className={styles['filter-select']}> 
            <select onChange={this.handleChange} value={this.state.selection}>
                {options}
            </select>
        </div>
    }

}

class DynamicOptGroupSelect extends Component {

    static contextType = LanguageContext

    constructor(props, context) {
        super(props, context);    

        this.state = {
            selection: !!this.props.selection ? this.props.selection : ''
        }
    }

    handleChange = (event) => {
        let selectedValue = !!event.target.value ? event.target.value : null;
        this.props.onSelectChange(selectedValue);
        this.setState({selection: event.target.value});
    }

    render() {
        const optionsGroup = [];
        const defaultSelection = <option key={0} value={''}> {this.props.title} </option>;
        optionsGroup.push(defaultSelection);

        this.props.data.forEach(item => {
            const options = item.options.map((option, index) => <option key={index} value={option}> {this.context[`EVT_${option}`]} </option>);
            optionsGroup.push(<optgroup label={this.context[item.group]} key={item.group}>
                {options}
            </optgroup>);
        });

        return <div className={styles['filter-select']}> 
            <select className="filter-select-option" onChange={this.handleChange} value={this.state.selection}>
                {optionsGroup}
            </select>
        </div>
    }

}

const LogList = function (props) {
    return <tbody>
        {props.logs.map((log, index) => {
            log.index = index;

            return <LogListItem
                key={index}
                index={index}
                onRowClicked={props.onRowClicked}
                log={log}/>
        })}
    </tbody>
}

const LogListItem = function (props) {
    const log = props.log;

    return <tr className={styles['editor-row-clickable']} onClick={() => props.onRowClicked(log)}>
        <td>{log.moduleName}</td>
        <td>{log.actionName}</td>
        <td>{log.eventName}</td>
        <td>{log.userName}</td>
        <td>{log.date}</td>
    </tr>
}

const LogDetailDisplay = function (props) {
    const log = props.log;
    const context = props.context;

    return <div className="card">
            <div className="card-header">
                Log
            </div>
            <div className={`card-body ${styles['editor-rows']}`}>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className="col-md-4">
                        <p className={styles['editor-form-control-label']}>{context['MODULE']}</p>
                    </div>
                    <div className="col-md-8">
                        <input className={styles['editor-form-control']} type="text" value={context[log.module]} readOnly />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className="col-md-4">
                        <p className={styles['editor-form-control-label']}>{context['ACTION']}</p>
                    </div>
                    <div className="col-md-8">
                        <input className={styles['editor-form-control']} type="text" value={context[log.action]} readOnly />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className="col-md-4">
                        <p className={styles['editor-form-control-label']}>{context['EVENT']}</p>
                    </div>
                    <div className="col-md-8">
                        <input className={styles['editor-form-control']} type="text" value={context[`EVT_${log.event}`]} readOnly />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className="col-md-4">
                        <p className={styles['editor-form-control-label']}>{context['USER']}</p>
                    </div>
                    <div className="col-md-8">
                        <input className={styles['editor-form-control']} type="text" value={log.userName} readOnly />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className="col-md-4">
                        <p className={styles['editor-form-control-label']}>{context['DATE']}</p>
                    </div>
                    <div className="col-md-8">
                        <input className={styles['editor-form-control']} type="text" value={log.date} readOnly />
                    </div>
                </div>
            </div>
            <div className="card-footer">
                <span className="float-right">
                    <Button variant="danger" onClick={() => props.onClose()}>
                        {context['CLOSE']}
                    </Button>
                </span>
            </div>
        </div>
}